import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message, Modal } from "antd";

import { TeamMemberTaskStatus } from "@fitness-app/data-models/entities/TeamMemberTask";
import { getErrorMessage } from "@fitness-app/utils";

import { analyticsService, supabase } from "~/store/initializeStore";
import { TEAM_MEMBER_TASKS_QUERY_KEY } from "./useTeamMemberTasks";
import { TEAM_MEMBER_TASKS_COUNT_QUERY_KEY } from "./useTeamMemberTasksCount";
import { TEAM_MEMBER_TASKS_DUE_TODAY_PLANNED_COUNT_QUERY_KEY } from "./useTeamMemberTasksDueTodayOrPlannedCount";

export const useDeleteTeamMemberTask = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (taskId: string) => {
      await supabase
        .from("team_member_task")
        .update({
          status: TeamMemberTaskStatus.Canceled,
          updatedAt: new Date().toISOString(),
        })
        .eq("id", taskId)
        .throwOnError();

      return taskId;
    },
    onSuccess: () => {
      void message.success("Zadanie zostało usunięte");
      void queryClient.invalidateQueries({ queryKey: [TEAM_MEMBER_TASKS_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [TEAM_MEMBER_TASKS_COUNT_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [TEAM_MEMBER_TASKS_DUE_TODAY_PLANNED_COUNT_QUERY_KEY] });
      void analyticsService.track("team_member_task_deleted");
    },
    onError: (error) => {
      void message.error(`Nie udało się usunąć zadania: ${getErrorMessage(error)}`);
    },
  });

  const confirmDelete = (taskId: string, taskTitle: string) => {
    Modal.confirm({
      title: "Czy na pewno chcesz usunąć to zadanie?",
      content: `Zadanie "${taskTitle}" zostanie usunięte.`,
      okText: "Usuń",
      cancelText: "Anuluj",
      okButtonProps: { danger: true },
      onOk: () => mutation.mutateAsync(taskId),
    });
  };

  return {
    mutation,
    confirmDelete,
    isLoading: mutation.isLoading,
  };
};
